"use client";
import {Breadcrumb} from "antd";
import {HomeOutlined} from "@ant-design/icons";
import ThemeLink from "@/components/link";
import {usePathname} from "next/navigation";
import {useEffect, useState} from "react";
import clsx from "clsx";
import {
    getCenterAccountInfoLink,
    getCenterAccountLink,
    getCenterAddressLink,
    getCenterCollectLink,
    getCenterFootprintLink,
    getCenterInquiryLink,
    getCenterInvoiceLink,
    getCenterLink,
    getCenterMessageLink,
    getCenterOrderDetailLink,
    getCenterOrderExchangeLink,
    getCenterOrderLink,
    getCenterPointsDetailLink,
    getCenterPointsLink,
    getCenterShopcartLink
} from "@/lib/util/get-router";

type Props = {
    children: React.ReactNode
}


const menus = [
    {
        "id": 14,
        "name": "个人中心",
        "link": getCenterLink()
    },
    {
        "id": 1,
        "name": "账户信息",
        "link": getCenterAccountInfoLink()
    },
    {
        "id": 2,
        "name": "账户安全",
        "link": getCenterAccountLink()
    },
    {
        "id": 3,
        "name": "收货地址",
        "link": getCenterAddressLink()
    },
    {
        "id": 4,
        "name": "我的消息",
        "link": getCenterMessageLink()
    },
    {
        "id": 5,
        "name": "发票管理",
        "link": getCenterInvoiceLink()
    },
    {
        "id": 6,
        "name": "我的足迹",
        "link": getCenterFootprintLink()
    },
    {
        "id": 7,
        "name": "订单管理",
        "link": getCenterOrderLink()
    },
    {
        "id": 8,
        "name": "我的订单",
        "link": getCenterOrderDetailLink()
    },
    {
        "id": 9,
        "name": "我的询价",
        "link": getCenterInquiryLink()
    },
    {
        "id": 10,
        "name": "我的收藏",
        "link": getCenterCollectLink()
    },
    {
        "id": 11,
        "name": "我的积分",
        "link": getCenterPointsLink()
    },
    // {
    //     "id": 12,
    //     "name": "积分详情",
    //     "link": getCenterPointsDetailLink()
    // },
    {
        "id": 13,
        "name": "兑换列表",
        "link": getCenterOrderExchangeLink()
    },
    {
        "id": 15,
        "name": "我的购物车",
        "link": getCenterShopcartLink()
    }
];


export default function CenterLayout({
                                         children
                                     }: Props) {
    const pathname = usePathname();
    const [activeId, setActiveId] = useState<number>(menus.find(item => item.link === pathname)!.id);
    const [breadItems, setBreadItems] = useState([{
        title: <ThemeLink href="/"><HomeOutlined/> 首页</ThemeLink>
    }]);
    useEffect(() => {
        setActiveId(menus.find(item => item.link === pathname)!.id);
        setBreadItems([{
            title: <ThemeLink href="/"><HomeOutlined/> 首页</ThemeLink>
        }, {
            title: <span>{menus.find(item => item.id === activeId)!.name}</span>
        }]);
    }, [pathname]);
    return <div className="bg-mainBg">
        <div className="container py-12 bg-mainBg">
            <Breadcrumb items={breadItems}/>
            <div className="grid grid-cols-10 gap-x-4 mt-8">
                <div className="col-span-2 bg-white">
                    <ul className="c-flex flex-col text-center text-[16px]">
                        <li className="py-3 font-bold text-md">
                            账号管理
                        </li>
                        {
                            menus.map((item, index) => {
                                return <li key={item.id}
                                           className={clsx("w-full", index === menus.length - 1 ? "border-b" : "")}>
                                    <ThemeLink href={item.link}
                                               className={clsx("py-3 w-full h-full  hover:bg-main hover:!text-white block", item.id === activeId ? "text-white bg-main" : "")}>
                                        {item.name}
                                    </ThemeLink>
                                </li>;
                            })
                        }
                    </ul>
                </div>
                <div className="col-span-8">
                    {children}
                </div>
            </div>
        </div>
    </div>;
}
